import _Math$trunc from "@babel/runtime-corejs3/core-js/math/trunc";
import Err from "@Broker/@Routes/error";
import { MORTGAGE_FREQUENCY, MORTGAGE_COMPOUNDING_PERIOD } from "@Shared/@Types/application/application-enums";
import { formatMoneyValueLong } from "@Shared/@Utils/helpers/money";
import i18n from "@Shared/@i18n/index";
export function formatMoney(val) {
  return formatMoneyValueLong(val);
}
export function formatRate(val) {
  return val && val > 0 ? this.$options.filters.parsePercentageDecimal(val / 100) : "-";
}
export function formatTerm(val) {
  return !val || val <= 0 ? "" : _Math$trunc(val / 12) + " " + i18n.t("financial-tools.year_abbr") + " " + Math.round(val % 12) + " " + i18n.t("financial-tools.month_abbr");
}
export function round2(val) {
  return Math.round(val * 100.0) / 100.0;
}
export function newMortgageScenarios() {
  return {
    scenarioId: 0,
    savedSelected: false,
    totalLoanAmount: 0,
    netRate: 0,
    paymentFrequencyDd: "",
    amortizationTerm: 0,
    actualPaymentTerm: 0,
    pAndIPaymentAmountMonthly: 0,
    pAndIPaymentAmount: 0,
    principalFirstPaymentAmount: 0,
    interestFirstPaymentAmount: 0,
    effectiveAmortization: 0,
    balanceRemaining: 0,
    calcTypeFlag: "",
    savedScenarioId: 0,
    interestCompoundDd: MORTGAGE_COMPOUNDING_PERIOD.SEMI_ANNUALLY,
    termPrincipal: 0,
    termInterest: 0,
    amortizationPrincipal: 0,
    amortizationInterest: 0,
    mortgageTypeDd: 0,
    selectionFlag: "",
    interestDifference: 0
  };
}
export function newMortgageScenariosBean() {
  const beana = {
    editedMortgageScenario: newMortgageScenarios(),
    calcMortgageScenario: newMortgageScenarios(),
    generatedMS: [],
    selectedMS: [],
    savedScenariosList: [],
    saveMS: [false, false, false, false, false, false],
    numOfSavedScenarios: 0,
    maxMortYears: 0,
    userMortAmount: 0,
    userPayment: 0,
    calcMinPayment: 0,
    maxScenNumAllowed: -1,
    assumedMaxAmortization: 35
  };
  for (const mf in MORTGAGE_FREQUENCY) beana.generatedMS.push(newMortgageScenarios());
  for (let msi = 0; msi < 3; msi++) beana.selectedMS.push(newMortgageScenarios());
  return beana;
}
export function copyFrom(toThis, fromms) {
  toThis.totalLoanAmount = fromms.totalLoanAmount;
  toThis.netRate = fromms.netRate;
  toThis.paymentFrequencyDd = fromms.paymentFrequencyDd;
  toThis.amortizationTerm = fromms.amortizationTerm;
  toThis.actualPaymentTerm = fromms.actualPaymentTerm;
  toThis.pAndIPaymentAmountMonthly = fromms.pAndIPaymentAmountMonthly;
  toThis.pAndIPaymentAmount = fromms.pAndIPaymentAmount;
  toThis.principalFirstPaymentAmount = fromms.principalFirstPaymentAmount;
  toThis.interestFirstPaymentAmount = fromms.interestFirstPaymentAmount;
  toThis.effectiveAmortization = fromms.effectiveAmortization;
  toThis.balanceRemaining = fromms.balanceRemaining;
  toThis.calcTypeFlag = fromms.calcTypeFlag;
  toThis.interestCompoundDd = fromms.interestCompoundDd;
  toThis.termPrincipal = fromms.termPrincipal;
  toThis.termInterest = fromms.termInterest;
  toThis.amortizationPrincipal = fromms.amortizationPrincipal;
  toThis.amortizationInterest = fromms.amortizationInterest;
  toThis.savedScenarioId = fromms.savedScenarioId;
  return toThis;
}
export function CalcBean() {
  const NUMBER_OF_DAYS_IN_A_YEAR = 365;
  const NUMBER_OF_MONTHS_IN_A_YEAR = 12;
  const NUMBER_OF_DAYS_IN_A_WEEK = 7;
  const MAX_VALUE_ALLOWED_IN_DB_TABLE = 100000000000;
  const ROUND_UP_PRECISION = 0.99999999999999;
  function getInterestCompoundingFrequency(interestCompundFrequencyDd) {
    return interestCompundFrequencyDd == MORTGAGE_COMPOUNDING_PERIOD.MONTHLY ? 12 : 2;
  }
  function getPaymentsPerYear(paymentFrequencyDd) {
    if (paymentFrequencyDd == MORTGAGE_FREQUENCY.MONTHLY) {
      return NUMBER_OF_MONTHS_IN_A_YEAR;
    } else if (paymentFrequencyDd == MORTGAGE_FREQUENCY.SEMI_MONTHLY) {
      return NUMBER_OF_MONTHS_IN_A_YEAR * 2;
    } else if (paymentFrequencyDd == MORTGAGE_FREQUENCY.BIWEEKLY || paymentFrequencyDd == MORTGAGE_FREQUENCY.ACCELERATED_BIWEEKLY) {
      return _Math$trunc(NUMBER_OF_DAYS_IN_A_YEAR / (NUMBER_OF_DAYS_IN_A_WEEK * 2));
    } else if (paymentFrequencyDd == MORTGAGE_FREQUENCY.WEEKLY || paymentFrequencyDd == MORTGAGE_FREQUENCY.ACCELERATED_WEEKLY) {
      return _Math$trunc(NUMBER_OF_DAYS_IN_A_YEAR / NUMBER_OF_DAYS_IN_A_WEEK);
    }
    return NUMBER_OF_MONTHS_IN_A_YEAR;
  }
  function calcFrequencyPayment(netInterestRate, paymentFrequencyDd, totalLoanAmount, interestCompundFrequencyDd, amortizationMonths) {
    const netInterestRateBigD = netInterestRate;
    const totalLoanAmountBigD = totalLoanAmount;
    let ret = -1;
    try {
      const paymentsPerYearBigD = paymentFrequencyDd == MORTGAGE_FREQUENCY.ACCELERATED_BIWEEKLY || paymentFrequencyDd == MORTGAGE_FREQUENCY.ACCELERATED_WEEKLY ? NUMBER_OF_MONTHS_IN_A_YEAR : getPaymentsPerYear(paymentFrequencyDd);
      const interestCompoundingFrequencyBigD = getInterestCompoundingFrequency(interestCompundFrequencyDd);
      const nominalInterestRate = netInterestRateBigD / 100.0;
      const effectiveRateBase = nominalInterestRate / interestCompoundingFrequencyBigD + 1;
      const effectiveRateExponent = interestCompoundingFrequencyBigD;
      const effectiveRate = Math.pow(effectiveRateBase, effectiveRateExponent) - 1;
      const tempBase = effectiveRate + 1;
      const tempExponent = 1 / paymentsPerYearBigD;
      const temp = Math.pow(tempBase, tempExponent);
      const tempInterestRate = (temp - 1) * paymentsPerYearBigD;
      const interestRatePerPayPeriod = tempInterestRate / paymentsPerYearBigD;
      const totalNumOfPaymentPeriodsAmort = amortizationMonths / 12 * paymentsPerYearBigD;
      let factor = 1;
      if (paymentFrequencyDd == MORTGAGE_FREQUENCY.MONTHLY || paymentFrequencyDd == MORTGAGE_FREQUENCY.SEMI_MONTHLY || paymentFrequencyDd == MORTGAGE_FREQUENCY.BIWEEKLY || paymentFrequencyDd == MORTGAGE_FREQUENCY.WEEKLY) {
        factor = 1;
      } else if (paymentFrequencyDd == MORTGAGE_FREQUENCY.ACCELERATED_BIWEEKLY) {
        factor = 2;
      } else if (paymentFrequencyDd == MORTGAGE_FREQUENCY.ACCELERATED_WEEKLY) {
        factor = 4;
      }
      const dividend = Math.pow(interestRatePerPayPeriod + 1, totalNumOfPaymentPeriodsAmort) * interestRatePerPayPeriod;
      const divisor = Math.pow(1 + interestRatePerPayPeriod, totalNumOfPaymentPeriodsAmort) - 1;
      const temp1 = dividend / divisor;
      const temp2 = temp1 * totalLoanAmountBigD;
      let frequencyPayment = temp2 / factor;
      frequencyPayment = Math.ceil(frequencyPayment * 100) / 100;
      ret = frequencyPayment;
    } catch (e) {
      Err.handle("Exception duriing arithmetic operation" + e);
      return -1;
    }
    if (ret >= MAX_VALUE_ALLOWED_IN_DB_TABLE) throw new Error("calcFrequencyPayment exceeded max::" + MAX_VALUE_ALLOWED_IN_DB_TABLE);
    return ret;
  }
  function calcEffectiveAmortization(netInterestRate, totalLoanAmount, interestCompundFrequencyDd, paymentFrequencyDd, frequencyPayment) {
    const netInterestRateBigD = netInterestRate;
    const totalLoanAmountBigD = totalLoanAmount;
    const frequencyPaymentBigD = frequencyPayment;
    let ret = -1;
    try {
      const paymentsPerYearBigD = getPaymentsPerYear(paymentFrequencyDd);
      const interestCompoundingFrequencyBigD = getInterestCompoundingFrequency(interestCompundFrequencyDd);
      const nominalInterestRate = netInterestRateBigD / 100.0;
      const effectiveRateBase = nominalInterestRate / interestCompoundingFrequencyBigD + 1;
      const effectiveRateExponent = interestCompoundingFrequencyBigD;
      const effectiveRate = Math.pow(effectiveRateBase, effectiveRateExponent) - 1;
      const tempBase = effectiveRate + 1.0;
      const tempExponent = 1.0 / paymentsPerYearBigD;
      const temp = Math.pow(tempBase, tempExponent);
      const tempInterestRate = (temp - 1.0) * paymentsPerYearBigD;
      const interestRatePerPayPeriod = tempInterestRate / paymentsPerYearBigD;
      let temp1 = totalLoanAmountBigD * interestRatePerPayPeriod;
      temp1 = frequencyPaymentBigD - temp1;
      if (temp1 < 0) {
        return -1;
      }
      temp1 = frequencyPaymentBigD / temp1;
      temp1 = Math.log(temp1);
      const temp2 = Math.log(1 + interestRatePerPayPeriod);
      const totalNoOfPaymentPeriods = temp1 / temp2;
      const effectiveAmortizationInMonths = totalNoOfPaymentPeriods / paymentsPerYearBigD * 12;
      ret = effectiveAmortizationInMonths;
    } catch (e) {
      Err.handle("Exception duriing arithmetic operation" + e);
      return -1;
    }
    if (ret >= MAX_VALUE_ALLOWED_IN_DB_TABLE) throw new Error("calcEffectiveAmortization exceeded max::" + MAX_VALUE_ALLOWED_IN_DB_TABLE);
    return ret;
  }
  function calcBalanceRemaining(actualPaymentTerm, netInterestRate, totalLoanAmount, interestCompundFrequencyDd, paymentFrequencyDd, frequencyPayment) {
    const netInterestRateBigD = netInterestRate;
    const totalLoanAmountBigD = totalLoanAmount;
    const frequencyPaymentBigD = frequencyPayment;
    const actualPaymentTermBigD = actualPaymentTerm;
    let ret = -1;
    try {
      const paymentsPerYearBigD = getPaymentsPerYear(paymentFrequencyDd);
      let numberOfPaymentsInTerm = actualPaymentTermBigD / 12.0;
      numberOfPaymentsInTerm = numberOfPaymentsInTerm * paymentsPerYearBigD;
      numberOfPaymentsInTerm = Math.ceil(numberOfPaymentsInTerm);
      const interestCompoundingFrequencyBigD = getInterestCompoundingFrequency(interestCompundFrequencyDd);
      const nominalInterestRate = netInterestRateBigD / 100.0;
      const effectiveRateBase = nominalInterestRate / interestCompoundingFrequencyBigD + 1;
      const effectiveRateExponent = interestCompoundingFrequencyBigD;
      const effectiveRate = Math.pow(effectiveRateBase, effectiveRateExponent) - 1.0;
      const tempBase = effectiveRate + 1.0;
      const tempExponent = 1.0 / paymentsPerYearBigD;
      let temp = Math.pow(tempBase, tempExponent);
      const tempInterestRate = (temp - 1.0) * paymentsPerYearBigD;
      const interestRatePerPayPeriod = tempInterestRate / paymentsPerYearBigD;
      let temp1 = totalLoanAmountBigD * interestRatePerPayPeriod;
      temp1 = frequencyPaymentBigD - temp1;
      if (temp1 < 0) {
        return -1;
      }
      temp1 = frequencyPaymentBigD / temp1;
      temp1 = Math.log(temp1);
      const temp2 = Math.log(1 + interestRatePerPayPeriod);
      let totalNoOfPaymentPeriods = temp1 / temp2;
      totalNoOfPaymentPeriods = Math.ceil(totalNoOfPaymentPeriods);
      let balanceRemaining;
      if (numberOfPaymentsInTerm < totalNoOfPaymentPeriods) {
        temp = Math.pow(interestRatePerPayPeriod + 1.0, numberOfPaymentsInTerm);
        temp = temp * totalLoanAmountBigD;
        temp1 = Math.pow(interestRatePerPayPeriod + 1.0, numberOfPaymentsInTerm) - 1.0;
        temp1 = temp1 * frequencyPaymentBigD / interestRatePerPayPeriod;
        balanceRemaining = round2(temp - temp1);
      } else {
        balanceRemaining = 0.0;
      }
      ret = balanceRemaining;
    } catch (e) {
      Err.handle("Exception duriing arithmetic operation" + e);
      return -1;
    }
    if (ret >= MAX_VALUE_ALLOWED_IN_DB_TABLE) throw new Error("calcBalanceRemaining exceeded max::" + MAX_VALUE_ALLOWED_IN_DB_TABLE);
    return ret;
  }
  function calcFirstPaymentInterest(netInterestRate, totalLoanAmount, interestCompundFrequencyDd, paymentFrequencyDd) {
    const netInterestRateBigD = netInterestRate;
    const totalLoanAmountBigD = totalLoanAmount;
    let ret = -1;
    try {
      const paymentsPerYearBigD = getPaymentsPerYear(paymentFrequencyDd);
      const interestCompoundingFrequencyBigD = getInterestCompoundingFrequency(interestCompundFrequencyDd);
      const nominalInterestRate = netInterestRateBigD / 100.0;
      const effectiveRateBase = nominalInterestRate / interestCompoundingFrequencyBigD + 1;
      const effectiveRateExponent = interestCompoundingFrequencyBigD;
      const effectiveRate = Math.pow(effectiveRateBase, effectiveRateExponent) - 1.0;
      const tempBase = effectiveRate + 1.0;
      const tempExponent = 1.0 / paymentsPerYearBigD;
      const temp = Math.pow(tempBase, tempExponent);
      const tempInterestRate = (temp - 1) * paymentsPerYearBigD;
      const interestRatePerPayPeriod = tempInterestRate / paymentsPerYearBigD;
      let firstPaymentInterest = totalLoanAmountBigD * interestRatePerPayPeriod;
      firstPaymentInterest = round2(firstPaymentInterest);
      ret = firstPaymentInterest;
    } catch (e) {
      Err.handle("Exception duriing arithmetic operation" + e);
      return -1;
    }
    if (ret >= MAX_VALUE_ALLOWED_IN_DB_TABLE) throw new Error("calcFirstPaymentInterest exceeded max::" + MAX_VALUE_ALLOWED_IN_DB_TABLE);
    return ret;
  }
  function calcFirstPaymentPriciple(firstPaymentInterest, frequencyPayment) {
    let firstPaymentPrinciple;
    let ret = -1;
    try {
      firstPaymentPrinciple = frequencyPayment - firstPaymentInterest;
      firstPaymentPrinciple = round2(firstPaymentPrinciple);
      ret = firstPaymentPrinciple;
    } catch (e) {
      Err.handle("Exception duriing arithmetic operation" + e);
      return -1;
    }
    if (ret >= MAX_VALUE_ALLOWED_IN_DB_TABLE) throw new Error("calcFirstPaymentPriciple exceeded max::" + MAX_VALUE_ALLOWED_IN_DB_TABLE);
    return ret;
  }
  function calcTermInterest(actualPaymentTerm, interestCompundFrequencyDd, netInterestRate, totalLoanAmount, frequencyPayment, paymentFrequencyDd, termPrincipal) {
    const netInterestRateBigD = netInterestRate;
    const totalLoanAmountBigD = totalLoanAmount;
    const frequencyPaymentBigD = frequencyPayment;
    const actualPaymentTermBigD = actualPaymentTerm;
    let ret = -1;
    try {
      const paymentsPerYearBigD = getPaymentsPerYear(paymentFrequencyDd);
      let numberOfPaymentsInTerm = actualPaymentTermBigD / 12.0;
      numberOfPaymentsInTerm = numberOfPaymentsInTerm * paymentsPerYearBigD;
      numberOfPaymentsInTerm = Math.ceil(numberOfPaymentsInTerm);
      const interestCompoundingFrequencyBigD = getInterestCompoundingFrequency(interestCompundFrequencyDd);
      const nominalInterestRate = netInterestRateBigD / 100.0;
      const effectiveRateBase = nominalInterestRate / interestCompoundingFrequencyBigD + 1.0;
      const effectiveRateExponent = interestCompoundingFrequencyBigD;
      const effectiveRate = Math.pow(effectiveRateBase * 1.0, effectiveRateExponent) - 1.0;
      const tempBase = effectiveRate + 1.0;
      const tempExponent = 1.0 / paymentsPerYearBigD;
      let temp = Math.pow(tempBase * 1.0, tempExponent * 1.0);
      const tempInterestRate = (temp - 1.0) * paymentsPerYearBigD;
      const interestRatePerPayPeriod = tempInterestRate / paymentsPerYearBigD;
      let temp1 = totalLoanAmountBigD * interestRatePerPayPeriod;
      temp1 = frequencyPaymentBigD - temp1;
      if (temp1 < 0) {
        return -1;
      }
      temp1 = frequencyPaymentBigD / temp1;
      temp1 = Math.log(temp1 * 1.0);
      const temp2 = Math.log(1 + interestRatePerPayPeriod * 1.0);
      let totalNoOfPaymentPeriods = temp1 / temp2;
      totalNoOfPaymentPeriods = Math.ceil(totalNoOfPaymentPeriods);
      let termInterest;
      if (numberOfPaymentsInTerm < totalNoOfPaymentPeriods) {
        termInterest = numberOfPaymentsInTerm * frequencyPayment;
        termInterest = termInterest - termPrincipal;
      } else {
        temp = Math.pow(interestRatePerPayPeriod + 1.0, _Math$trunc(totalNoOfPaymentPeriods) - 1);
        temp1 = temp;
        temp = temp * totalLoanAmountBigD;
        temp1 -= 1.0;
        temp1 = temp1 * frequencyPaymentBigD / interestRatePerPayPeriod;
        const balanceRemainingBeforeLastPay = temp - temp1;
        temp = (totalNoOfPaymentPeriods - 1.0) * frequencyPayment;
        temp1 = (interestRatePerPayPeriod + 1.0) * balanceRemainingBeforeLastPay - totalLoanAmountBigD;
        termInterest = temp + temp1;
      }
      termInterest = round2(termInterest);
      ret = termInterest;
    } catch (e) {
      Err.handle("Exception duriing arithmetic operation" + e);
      return -1;
    }
    if (ret >= MAX_VALUE_ALLOWED_IN_DB_TABLE) throw new Error("calcTermInterest exceeded max::" + MAX_VALUE_ALLOWED_IN_DB_TABLE);
    return ret;
  }
  function calcTermPrinciple(actualPaymentTerm, netInterestRate, totalLoanAmount, interestCompundFrequencyDd, paymentFrequencyDd, frequencyPayment, balanceRemaining) {
    const netInterestRateBigD = netInterestRate;
    const totalLoanAmountBigD = totalLoanAmount;
    const actualPaymentTermBigD = actualPaymentTerm;
    let ret = -1;
    try {
      const paymentsPerYearBigD = getPaymentsPerYear(paymentFrequencyDd);
      const interestCompoundingFrequencyBigD = getInterestCompoundingFrequency(interestCompundFrequencyDd);
      const nominalInterestRate = netInterestRateBigD / 100.0;
      const effectiveRateBase = nominalInterestRate / interestCompoundingFrequencyBigD + 1.0;
      const effectiveRateExponent = interestCompoundingFrequencyBigD;
      const effectiveRate = Math.pow(effectiveRateBase, effectiveRateExponent) - 1.0;
      const tempBase = effectiveRate + 1.0;
      const tempExponent = 1.0 / paymentsPerYearBigD;
      const temp = Math.pow(tempBase, tempExponent);
      const tempInterestRate = (temp - 1.0) * paymentsPerYearBigD;
      const interestRatePerPayPeriod = tempInterestRate / paymentsPerYearBigD;
      let numberOfPaymentsInTerm = actualPaymentTermBigD / 12.0;
      numberOfPaymentsInTerm = numberOfPaymentsInTerm * paymentsPerYearBigD;
      numberOfPaymentsInTerm = Math.ceil(numberOfPaymentsInTerm);
      let temp1 = totalLoanAmountBigD * interestRatePerPayPeriod;
      temp1 = frequencyPayment - temp1;
      if (temp1 < 0) {
        return -1;
      }
      temp1 = frequencyPayment / temp1;
      temp1 = Math.log(temp1);
      const temp2 = Math.log(1 + interestRatePerPayPeriod);
      let totalNoOfPaymentPeriods = temp1 / temp2;
      totalNoOfPaymentPeriods = Math.ceil(totalNoOfPaymentPeriods);
      let termPrinciple;
      if (numberOfPaymentsInTerm < totalNoOfPaymentPeriods) {
        termPrinciple = totalLoanAmount - balanceRemaining;
        termPrinciple = round2(termPrinciple);
      } else {
        termPrinciple = totalLoanAmountBigD;
      }
      ret = termPrinciple;
    } catch (e) {
      Err.handle("Exception duriing arithmetic operation" + e);
      return -1;
    }
    if (ret >= MAX_VALUE_ALLOWED_IN_DB_TABLE) throw new Error("calcTermPrinciple exceeded max::" + MAX_VALUE_ALLOWED_IN_DB_TABLE);
    return ret;
  }
  function calcAmortizationInterest(netInterestRate, totalLoanAmount, interestCompundFrequencyDd, paymentFrequencyDd, frequencyPayment) {
    const netInterestRateBigD = netInterestRate;
    const totalLoanAmountBigD = totalLoanAmount;
    const frequencyPaymentBigD = frequencyPayment;
    let ret = -1;
    try {
      const paymentsPerYearBigD = getPaymentsPerYear(paymentFrequencyDd);
      const interestCompoundingFrequencyBigD = getInterestCompoundingFrequency(interestCompundFrequencyDd);
      const nominalInterestRate = netInterestRateBigD / 100.0;
      const effectiveRateBase = nominalInterestRate / interestCompoundingFrequencyBigD + 1.0;
      const effectiveRateExponent = interestCompoundingFrequencyBigD;
      const effectiveRate = Math.pow(effectiveRateBase, effectiveRateExponent) - 1.0;
      const tempBase = effectiveRate + 1.0;
      const tempExponent = 1.0 / paymentsPerYearBigD;
      let temp = Math.pow(tempBase, tempExponent);
      const tempInterestRate = (temp - 1.0) * paymentsPerYearBigD;
      const interestRatePerPayPeriod = tempInterestRate / paymentsPerYearBigD;
      let temp1 = totalLoanAmountBigD * interestRatePerPayPeriod;
      temp1 = frequencyPaymentBigD - temp1;
      temp1 = frequencyPaymentBigD / temp1;
      temp1 = Math.log(temp1);
      const temp2 = Math.log(1 + interestRatePerPayPeriod);
      let numberOfPaymentPeriodsInAmort = temp1 / temp2;
      numberOfPaymentPeriodsInAmort = Math.ceil(numberOfPaymentPeriodsInAmort);
      temp = Math.pow(interestRatePerPayPeriod + 1.0, _Math$trunc(numberOfPaymentPeriodsInAmort) - 1);
      temp1 = temp;
      temp = temp * totalLoanAmountBigD;
      temp1 -= 1.0;
      temp1 = temp1 * frequencyPaymentBigD / interestRatePerPayPeriod;
      const balanceRemainingBeforeLastPay = temp - temp1;
      temp = (numberOfPaymentPeriodsInAmort - 1.0) * frequencyPayment;
      temp1 = (interestRatePerPayPeriod + 1.0) * balanceRemainingBeforeLastPay - totalLoanAmountBigD;
      let amortInterest = temp + temp1;
      amortInterest = round2(amortInterest);
      ret = amortInterest;
    } catch (e) {
      Err.handle("Exception duriing arithmetic operation" + e);
      return -1;
    }
    if (ret >= MAX_VALUE_ALLOWED_IN_DB_TABLE) throw new Error("calcAmortizationInterest exceeded max::" + MAX_VALUE_ALLOWED_IN_DB_TABLE);
    return ret;
  }
  function calculateValuesOnMS(bean, ms, FreqType, assumedAmortization) {
    ms.paymentFrequencyDd = FreqType;
    const calcAmortFromPayment = ms.calcTypeFlag == "A";
    let fp = 0;
    if (calcAmortFromPayment) {
      fp = ms.pAndIPaymentAmountMonthly;
      if (FreqType == MORTGAGE_FREQUENCY.MONTHLY) {
        ms.pAndIPaymentAmount = ms.pAndIPaymentAmountMonthly;
        assumedAmortization = calcEffectiveAmortization(ms.netRate, ms.totalLoanAmount, ms.interestCompoundDd, ms.paymentFrequencyDd, fp);
      } else {
        const assumedAmortizationRA = ROUND_UP_PRECISION + assumedAmortization;
        ms.amortizationTerm = assumedAmortizationRA;
        if (FreqType == MORTGAGE_FREQUENCY.ACCELERATED_BIWEEKLY) {
          const pandIAmount = Math.round(ms.pAndIPaymentAmountMonthly * 50 + 0.4999999) / 100.0;
          ms.pAndIPaymentAmount = pandIAmount;
          fp = pandIAmount;
        } else if (FreqType == MORTGAGE_FREQUENCY.ACCELERATED_WEEKLY) {
          const pandIAmount = Math.round(ms.pAndIPaymentAmountMonthly * 25 + 0.4999999) / 100.0;
          ms.pAndIPaymentAmount = pandIAmount;
          fp = pandIAmount;
        } else {
          fp = calcFrequencyPayment(ms.netRate, ms.paymentFrequencyDd, ms.totalLoanAmount, ms.interestCompoundDd, assumedAmortization);
          ms.pAndIPaymentAmount = fp;
        }
        const fpm = calcFrequencyPayment(ms.netRate, MORTGAGE_FREQUENCY.MONTHLY, ms.totalLoanAmount, ms.interestCompoundDd, assumedAmortization);
        ms.pAndIPaymentAmountMonthly = fpm;
      }
    } else {
      fp = calcFrequencyPayment(ms.netRate, ms.paymentFrequencyDd, ms.totalLoanAmount, ms.interestCompoundDd, ms.amortizationTerm);
      ms.pAndIPaymentAmount = fp;
      const fpm = calcFrequencyPayment(ms.netRate, MORTGAGE_FREQUENCY.MONTHLY, ms.totalLoanAmount, ms.interestCompoundDd, ms.amortizationTerm);
      ms.pAndIPaymentAmountMonthly = fpm;
    }
    const ea = calcEffectiveAmortization(ms.netRate, ms.totalLoanAmount, ms.interestCompoundDd, ms.paymentFrequencyDd, fp);
    const eaRA = Math.ceil(ea);
    ms.effectiveAmortization = _Math$trunc(eaRA);
    if (calcAmortFromPayment) {
      ms.amortizationTerm = _Math$trunc(eaRA);
    }
    const bm = calcBalanceRemaining(ms.actualPaymentTerm, ms.netRate, ms.totalLoanAmount, ms.interestCompoundDd, ms.paymentFrequencyDd, fp);
    ms.balanceRemaining = bm;
    const fip = calcFirstPaymentInterest(ms.netRate, ms.totalLoanAmount, ms.interestCompoundDd, ms.paymentFrequencyDd);
    ms.interestFirstPaymentAmount = fip;
    const fpp = calcFirstPaymentPriciple(fip, ms.pAndIPaymentAmount);
    ms.principalFirstPaymentAmount = fpp;
    const fi = calcTermPrinciple(ms.actualPaymentTerm, ms.netRate, ms.totalLoanAmount, ms.interestCompoundDd, ms.paymentFrequencyDd, ms.pAndIPaymentAmount, bm);
    ms.termPrincipal = fi;
    const ti = calcTermInterest(ms.actualPaymentTerm, ms.interestCompoundDd, ms.netRate, ms.totalLoanAmount, ms.pAndIPaymentAmount, ms.paymentFrequencyDd, fi);
    ms.termInterest = ti;
    const am = calcAmortizationInterest(ms.netRate, ms.totalLoanAmount, ms.interestCompoundDd, ms.paymentFrequencyDd, ms.pAndIPaymentAmount);
    ms.amortizationInterest = am;
    ms.amortizationPrincipal = ms.totalLoanAmount;
    return assumedAmortization;
  }
  return {
    newMortgageScenariosBean,
    newMortgageScenarios,
    round2,
    calculateValuesOnMS,
    calcFrequencyPayment,
    calcEffectiveAmortization,
    calcTermInterest,
    calcTermPrinciple,
    calcAmortizationInterest
  };
}